var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalTabs2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 30,
    viewBox: "0 0 67 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10700",
    d: "M0.25 0.25H88.75V29.75H0.25V0.25Z",
    fill: "white",
    stroke: "#7C7C7C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 52894",
    d: "M29.25 0.25H59.4026V7.75H29.25V0.25Z",
    fill: "white",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10698",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H31V8H0V0Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 52895",
    d: "M58.25 0.25H88.9237V7.75H58.25V0.25Z",
    fill: "white",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2179",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.594727 7.5H30.3225H0.594727Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23986",
    x: 6,
    y: 0.800049,
    width: 16,
    height: 5,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23987",
    x: 36,
    y: 1.30005,
    width: 16,
    height: 5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23988",
    x: 66,
    y: 1.30005,
    width: 16,
    height: 5,
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTabs2A);
export default __webpack_public_path__ + "static/media/HorizontalTabs2A.25b348d48782d6416b0cd438a40fcc4f.svg";
export { ForwardRef as ReactComponent };